import UnitOfMeasurementDetails from "./UnitOfMeasurementDetails";

export default UnitOfMeasurementDetails;
